import Head from 'next/head';
import {useTranslation} from 'next-i18next';

import {Box, Stack} from '@tempo/core';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useRouter} from 'next/router';

import {ScanningWaveLoader} from '@components/common/ScanningWaveLoader';
import {useTrackScreenView} from '@modules/analytics/useTrackScreenView';
import {withCommonTranslations} from '@modules/i18n/withCommonTranslations';
import {useTmmLaunchFlow} from '@modules/tmm/useTmmLaunchFlow';

const IndexPage = () => {
	const {t} = useTranslation();
	const router = useRouter();
	const locale = router.locale ?? router.defaultLocale ?? 'en';

	useTmmLaunchFlow({
		enabled: typeof window !== 'undefined' && router.isReady,
		locale,
	});

	useTrackScreenView('spot_ai_landing', undefined, {
		pageTitle: t('generic_text_loading_standalone-web'),
	});

	return (
		<>
			<Head>
				<title>{t('generic_text_loading_standalone-web')}</title>
				<meta name="robots" content="noindex,nofollow" />
			</Head>
			<Box
				data-testid="EntryPage"
				minH="80vh"
				display="flex"
				alignItems="center"
				justifyContent="center"
				px={['spacing.l', 'spacing.xl']}
				py={['spacing.2xl', 'spacing.4xl']}
			>
				<Stack
					maxW="622px"
					spacing="spacing.xl"
					align="center"
					textAlign="center"
				>
					<ScanningWaveLoader />
					<Stack spacing="spacing.s" align="center" textAlign="center" w="100%">
						<LandingHeading as="h1" textAlign="center">
							{t('generic_text_loading_standalone-web')}
						</LandingHeading>
						<LandingParagraph textAlign="center">
							{t(
								'spotailoading_subtitle_gettingreadydescription_standalone-web',
							)}
						</LandingParagraph>
					</Stack>
				</Stack>
			</Box>
		</>
	);
};

export const getStaticProps = withCommonTranslations();

export default IndexPage;
